import * as d3 from 'd3'

export default {
  methods: {

    draw_exception() {
      let except = this.skyline.data.filter(f => f.EXCEPT == 'Y')

      let tableY = 48 // draw_Table()의 tableY와 동일
      let tableHeight = this.table.apply === 'Y' ? this.table.item.length * this.table.lineHeight : 0
      let gap = 20 // 표 하단과 예외 영역 제목 사이 간격

      if (except.length == 0) return

      // Sorting Date
      function executeSort(a, b) { 
        if(a.MCC_P == b.MCC_P){ return 0} return a.MCC_P > b.MCC_P ? 1 : -1; 
      } 
      except.sort(executeSort)


      let self = this
      this.canvasExcept = this.svg
      .append('g')
      .attr('id', 'EXCEPTION')
      .attr('transform', `translate(${this.timeline.x}, ${this.timeline.y + tableY + tableHeight + gap})`)
      .attr('font-family', 'roboto')

      this.canvasExcept
      .append('text')
      .attr('transform', `translate(0, 0)`)
      .attr('font-size', 11)
      .attr('fill', '#F35E90')
      .text('Blocks not included on the timeline')

      let x = 12
      let y = 10
      let width_ = this.skyline.width + 5


      except.forEach((d, i) => {

        
        let Boxes = this.canvasExcept
        .append('g')
        .attr('id', `BOX_${d.SUBSYS}`)
        .attr('transform', `translate(${x}, ${y})`)
        .style('cursor', 'pointer')
        .call(this.call_Skyline, d, x, y, width_)

        Boxes
        .append('rect') // Background
        .attr('x', 0).attr('y',0)
        .attr('rx', 2)
        .attr('ry', 2)
        .attr('width', width_)
        .attr('height', this.skyline.height)
        .attr('fill', '#fff')
        .attr('stroke', '#757575')
        .attr('stroke-width', .5)

        Boxes
        .append('rect') // Fill Color
        .attr('x', 0).attr('y',0)
        .attr('rx', 1)
        .attr('ry', 1)
        .attr('width', width_ * (d.A_PRO/100))
        .attr('height', this.skyline.height)
        .attr('fill', d.bColor)
        .attr('fill-opacity', 1)
      
        Boxes
        .append('text')
        .attr('x', width_/2)
        .attr('y', this.skyline.height/2 + 3)
        .attr('font-family', this.skyline.font)
        .attr('font-size', this.skyline.tSize)
        .attr('fill', '#000')
        .attr('text-anchor', 'middle')
        .style('pointer-events', 'none')
        .text(d.SUBSYS)

        let Sch = this.canvasExcept
        .append('text')
        .attr('x', x + width_ + 6)
        .attr('y', 22)
        .attr('font-family', this.skyline.font)
        .attr('font-size', 10)
        .attr('fill', '#000')
        .attr('text-anchor', 'start')
        .style('pointer-events', 'none')
        .text(d.MCC_P)

        x = x + 110
      })


    },
    

  }
}
